import { map } from 'rxjs';
import { convertToBehaviorSubject, stripLeadingChar, stripTrailingChar } from '@core/shared/utils';
import * as globToRegExp from 'glob-to-regexp';
import { DevToolsRegistry } from '../../dev-tools';
import { FeatureRouterLinkResolverService } from '../router-link-resolver';
import { FeatureService } from '../feature-registry';
import { AccessService } from '../../access/access/access.service';
import * as i0 from "@angular/core";
import * as i1 from "../feature-registry";
import * as i2 from "../router-link-resolver";
import * as i3 from "../../access/access/access.service";
import * as i4 from "../../dev-tools";
// frontend: injected in root as FeatureRouterLinkRedirectservice
// pipe is declared in CoreFeatureModule
export let RouterLinkRedirectsService = /*#__PURE__*/(() => {
  class RouterLinkRedirectsService {
    constructor(features, resolver, access,
    // private config:ConfigService,
    debug) {
      this.features = features;
      this.resolver = resolver;
      this.access = access;
      this.redirectsList$ = this.collectRouterLinkRedirects();
      debug.exposeDebugFunction(['Features', 'RouterLinkRedirects (only active)'], () => {
        return this.redirectsList$.getValue();
      });
    }
    getRouterLinkRedirects() {
      return this.redirectsList$.getValue();
    }
    findRedirect(urlTree) {
      const redirects = this.redirectsList$.getValue();
      if (!redirects.length) return null;
      const pathWithParams = urlTree.toString();
      const path = pathWithParams.includes('?') ? pathWithParams.substring(0, pathWithParams.indexOf('?')) : pathWithParams;
      const trimmedPath = stripLeadingChar(stripTrailingChar(path, '/'), '/');
      const match = redirects.find(r => {
        if (r.simpleAbilityCheck) {
          if (!this.access.simpleAbilityCheck(r.simpleAbilityCheck, false)) {
            return false;
          }
        }
        if (r.globMatch) {
          if (typeof r.matcher !== 'string') throw new Error('When enabling globMatch, matcher value must be a string!');
          if (!r['__globRegExp']) r['__globRegExp'] = globToRegExp(r.matcher);
          return r['__globRegExp'].test(path);
        } else if (typeof r.matcher === 'string') {
          const trimmedMatcher = stripLeadingChar(stripTrailingChar(r.matcher, '/'), '/');
          return trimmedPath === trimmedMatcher;
        } else if (r.matcher instanceof RegExp) {
          return r.matcher.test(pathWithParams);
        } else if (typeof r.matcher === 'function') {
          return r.matcher(pathWithParams, urlTree);
        }
      });
      return match || null;
    }
    applyRedirect(urlTree, r) {
      const path = urlTree.toString();
      let redirectResult;
      if (typeof r.redirect === 'string') {
        redirectResult = r.redirect;
      } else {
        redirectResult = r.redirect(path, urlTree, this.resolver.resolveRouterLink.bind(this.resolver));
      }
      if (typeof redirectResult === 'string') redirectResult = redirectResult.split('/');
      return redirectResult;
    }
    collectRouterLinkRedirects() {
      const base = this.features.getLoadedFeatures().pipe(map(featurePlugin => {
        const redirects = [];
        featurePlugin.forEach(plugin => {
          const definition = plugin.getFeatureFunctionalityCached();
          if (!definition.routerLinkRedirects) return;
          definition.routerLinkRedirects.forEach(redirectConfig => {
            redirects.push({
              ...redirectConfig,
              _origin: plugin.pluginName
            });
          });
        });
        return redirects;
      }));
      return convertToBehaviorSubject(null)(base);
    }
    static {
      this.ɵfac = function RouterLinkRedirectsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RouterLinkRedirectsService)(i0.ɵɵinject(i1.FeatureService), i0.ɵɵinject(i2.FeatureRouterLinkResolverService), i0.ɵɵinject(i3.AccessService), i0.ɵɵinject(i4.DevToolsRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: RouterLinkRedirectsService,
        factory: RouterLinkRedirectsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RouterLinkRedirectsService;
})();